import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Atto } from "../../../models/atto";
import { SezioneAttiFull } from '../../../models/sezioni/sezione-atti-full';
import { AttiAddConcreteFormComponent } from './atti-add-concrete-form.component';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [atti-mod-add]',
  templateUrl: 'atti-mod-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class AttiModAdd {
  @Output() onReturn: EventEmitter<SezioneAttiFull> = new EventEmitter<SezioneAttiFull>();
  @Output() onAttoInseritaForAuto: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDocumentiCaricati: EventEmitter<void> = new EventEmitter<void>();
  @Output() idSezione: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('formAttiAdd') formAtti: AttiAddConcreteFormComponent;

  inizializza(idSezione: string, idFascicolo: string, urlInsert: string, fascicolo: FascicoloFull) {
    this.formAtti.inizializza(idSezione, idFascicolo, urlInsert, fascicolo);
    openModal('modaladdAtti');
  }

  createForm() {
    this.formAtti.createForm();
  }

  manageModal(sezioneAtti: SezioneAttiFull) {
      closeModal('modaladdAtti');
      this.onReturn.emit(sezioneAtti);
  }

  eventoAttoInseritoForAuto(attoIns: Atto){
    this.onAttoInseritaForAuto.emit(attoIns);
  }
}
